import React from "react";
import BalanceTooltip from "src/components/wallets/header/BalanceTooltip";

interface QuestionMarkIconProps {
  tooltip: string;
  color?: string;
}

const QuestionMarkIcon = ({ tooltip, color = "#002035" }: QuestionMarkIconProps) => {
  return (
    <BalanceTooltip message={tooltip}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none">
        <g clipPath="url(#clip0_2861_9906)">
          <path
            d="M5.40002 10.1H6.60002V8.9H5.40002V10.1ZM6.00002 0.5C2.68802 0.5 1.52588e-05 3.188 1.52588e-05 6.5C1.52588e-05 9.812 2.68802 12.5 6.00002 12.5C9.31202 12.5 12 9.812 12 6.5C12 3.188 9.31202 0.5 6.00002 0.5ZM6.00002 11.3C3.35402 11.3 1.20002 9.146 1.20002 6.5C1.20002 3.854 3.35402 1.7 6.00002 1.7C8.64602 1.7 10.8 3.854 10.8 6.5C10.8 9.146 8.64602 11.3 6.00002 11.3ZM6.00002 2.9C4.67402 2.9 3.60002 3.974 3.60002 5.3H4.80002C4.80002 4.64 5.34002 4.1 6.00002 4.1C6.66002 4.1 7.20002 4.64 7.20002 5.3C7.20002 6.5 5.40002 6.35 5.40002 8.3H6.60002C6.60002 6.95 8.40002 6.8 8.40002 5.3C8.40002 3.974 7.32602 2.9 6.00002 2.9Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_2861_9906">
            <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>
    </BalanceTooltip>
  );
};

export default QuestionMarkIcon;
